import { apiPaths, mamutilsApi } from '@services';
import { SubmitServiceOrderArgs, SubmitServiceOrderResponse } from '../types';

const enhancedApi = mamutilsApi.enhanceEndpoints({
    addTagTypes: ['ServiceOrders'],
});

const extendedApi = enhancedApi.injectEndpoints({
    endpoints: (builder) => ({
        submitServiceOrder: builder.mutation<
            SubmitServiceOrderResponse,
            SubmitServiceOrderArgs<unknown>
        >({
            query: (payload) => ({
                method: 'POST',
                url: apiPaths.serviceOrders.submit(),
                body: payload,
            }),
            // invalidatesTags: ['ServiceOrders'],
        }),
    }),
});

export const { useSubmitServiceOrderMutation } = extendedApi;

export default extendedApi.endpoints;
